import { Reveal, Eyebrow } from "@/components/Reveal";
import { Users } from "lucide-react";

export const About = () => (
  <section id="minusta" className="py-24 sm:py-32" data-testid="about-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid grid-cols-1 items-start gap-12 lg:grid-cols-2 lg:gap-20">
        <div>
          <Reveal>
            <Eyebrow index="01" label="Minusta" />
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-6 font-serif text-4xl font-medium tracking-tight text-petrol-night sm:text-5xl">
              Hei, olen Kaisa.
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <div className="mt-7 space-y-5 text-base leading-relaxed text-mutedink sm:text-lg">
              <p>
                Olen 20-vuotias ja opiskelen tällä hetkellä psykologiaa avoimessa
                yliopistossa joka arkipäivä. Samalla haluan tehdä töitä, säästää
                sekä kokeilla yritysmaailmaa. Ja mikä olisikaan oivallisempaa kuin
                tehdä sitä, mistä tykkää, veljeni sanoin, ”kuin hullu puurosta” –
                nimittäin lastenhoitoa.
              </p>
              <p>
                Olen erittäin luonteva lasten kanssa ja siitä olenkin saanut
                palautetta jo nuoresta asti. Lasten kanssa olen ollut tekemisissä
                pitkään ja monella tavalla.
              </p>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.15} className="w-full max-w-xs sm:max-w-sm lg:mt-2 lg:justify-self-end">
          <div
            data-testid="about-photo"
            className="overflow-hidden rounded-[2rem] border-[6px] border-white shadow-[0_45px_80px_-35px_rgba(18,58,62,0.5)]"
          >
            <img
              src="/assets/kaisa-baby.jpg"
              alt="Kaisa pieni vauva sylissään"
              className="aspect-[4/5] w-full object-cover object-[50%_30%]"
            />
          </div>
        </Reveal>
      </div>

      <div className="mx-auto mt-14 max-w-3xl lg:mt-20">
        <Reveal delay={0.1}>
          <div className="space-y-5 text-base leading-relaxed text-mutedink sm:text-lg">
            <p>
              Säännöllistä lastenhoitoa olen tehnyt nyt noin vuoden ajan,
              viikoittain 1–4-vuotiaita lapsia hoitaen ja epäsäännöllisesti myös
              3–8-vuotiaita.
            </p>
            <p>
              Iso osa taustaani on myös kilpaurheilu: harrastin yleisurheilua
              SM-tasolle asti ja ohjasin samalla urheilukoulua 6–9-vuotiaille
              lapsille.
            </p>
            <p>
              Nyt päiväni vierivät psykologian opintojen parissa, joten hoidot
              sopivat parhaiten iltoihin ja viikonloppuihin sekä sovittaessa
              myös myöhään yöhön. Uuden perheen tavat ja rutiinit omaksun
              nopeasti: lastenhoidon tulee olla teille eduksi ja tuoda
              helpotusta arkeenne. Yrityksen taustalla on aito rakkauteni
              lapsiin ja halu tehdä lastenhoidosta jotain omaa.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-10 flex gap-5 rounded-2xl border border-beige-border/70 bg-beige/25 p-6 sm:p-7" data-testid="about-backup-note">
            <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-petrol text-cream">
              <Users className="h-5 w-5" strokeWidth={1.6} />
            </span>
            <p className="text-[0.95rem] leading-relaxed text-ink/85 sm:text-base">
              <span className="font-semibold text-petrol">Sijaisjärjestely tarvittaessa.</span>{" "}
              Jos toivomanne ajankohta ei satu sopimaan minulle, en jätä asiaa
              siihen: ystäväpiirissäni on useita kokeneita lastenhoitajia – osa
              työskentelee päiväkodeissa ja osa hoitaa lapsia omien yritystensä
              tai Sitly-sovelluksen kautta. Voin siis tarvittaessa järjestää
              teille sijaisen, ja saatte hänestä aina etukäteen tiedot, taustan
              hoitokokemuksesta sekä kuvan {"<3."}
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
